export default __webpack_public_path__ + "static/media/splitConduits1.49dc5f08.jpg";